import { render, staticRenderFns } from "./AiNavbar聊天窗口滚动.vue?vue&type=template&id=40ae14a6&scoped=true"
import script from "./AiNavbar聊天窗口滚动.vue?vue&type=script&lang=js"
export * from "./AiNavbar聊天窗口滚动.vue?vue&type=script&lang=js"
import style0 from "./AiNavbar聊天窗口滚动.vue?vue&type=style&index=0&id=40ae14a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae14a6",
  null
  
)

export default component.exports